const FR = {
  'outlander.interior.image-1.hotspot-1.label': 'Volant et tableau de bord',
  'outlander.interior.image-1.hotspot-1.message': 'Volant et tableau de bord',
  'outlander.interior.image-1.hotspot-2.label': 'Contrôle de la climatisation',
  'outlander.interior.image-1.hotspot-2.message': 'Contrôle de la climatisation',
  'outlander.interior.image-1.hotspot-3.label': 'Levier de vitesses et console centrale',
  'outlander.interior.image-1.hotspot-3.message': 'Levier de vitesses et console centrale',
  'outlander.interior.image-1.hotspot-4.label': 'Siège du conducteur',
  'outlander.interior.image-1.hotspot-4.message': 'Siège du conducteur',

  'outlander.interior.image-2.hotspot-1.label': 'Sièges rabattables de la 3e rangée',
  'outlander.interior.image-2.hotspot-1.message': 'Sièges rabattables de la 3e rangée',
  'outlander.interior.image-2.hotspot-2.label': 'Ceintures de sécurité et dispositifs de retenue',
  'outlander.interior.image-2.hotspot-2.message': 'Ceintures de sécurité et dispositifs de retenue',
  'outlander.interior.image-2.hotspot-3.label': 'Caractéristiques de sécurité active',
  'outlander.interior.image-2.hotspot-3.message': 'Caractéristiques de sécurité active',
  'outlander.interior.image-2.hotspot-4.label': 'Commodités de la 2e rangée',
  'outlander.interior.image-2.hotspot-4.message': 'Commodités de la 2e rangée',

  'outlander.exterior.hotspot-1.label': 'Moteur et transmission',
  'outlander.exterior.hotspot-1.message': 'Moteur à injection directe de 2,5 L à 4 cylindres',
  'outlander.exterior.hotspot-2.label': 'Technologie de conduite à quatre roues motrices',
  'outlander.exterior.hotspot-2.message':
    'Contrôle intégral des quatre roues motrices (S-AWC) avec sélecteur de mode de conduite',
  'outlander.exterior.hotspot-3.label': "Système d'entrée et de démarrage",
  'outlander.exterior.hotspot-3.message': "Système d'entrée et de démarrage",
  'outlander.exterior.hotspot-4.label': 'Roues et pneus',
  'outlander.exterior.hotspot-4.message': 'Roues et pneus',
  'outlander.exterior.hotspot-5.label': 'Caractéristiques arrière',
  'outlander.exterior.hotspot-5.message': 'Caractéristiques arrière',
  'outlander.exterior.hotspot-6.label': 'Pare-chocs et plaque de protection',
  'outlander.exterior.hotspot-6.message': 'Pare-chocs et plaque de protection',
  'outlander.exterior.hotspot-7.label': 'Hayon et bouchon de réservoir',
  'outlander.exterior.hotspot-7.message': 'Hayon et bouchon de réservoir',
  'outlander.exterior.hotspot-8.label': 'Rétroviseurs latéraux et poignées de porte',
  'outlander.exterior.hotspot-8.message': 'Rétroviseurs latéraux et poignées de porte',
  'outlander.exterior.hotspot-9.label': 'Fenêtres et essuie-glaces',
  'outlander.exterior.hotspot-9.message': 'Fenêtres et essuie-glaces',

  'outlander.blueprint.safety.tab-1': 'Rideaux et sièges',
  'outlander.blueprint.safety.tab-2': 'Coussin gonflable SRS pour les genoux de la première rangée',
  'outlander.blueprint.safety.hotspot-1.label': 'Coussin gonflable rideau latéral',
  'outlander.blueprint.safety.hotspot-1.message': 'Coussin gonflable rideau latéral',
  'outlander.blueprint.safety.hotspot-2.label': 'Coussin gonflable latéral monté sur le siège',
  'outlander.blueprint.safety.hotspot-2.message': 'Coussin gonflable monté sur le siège',
  'outlander.blueprint.safety.hotspot-3.label':
    'Coussin gonflable central\nmonté sur le siège avant',
  'outlander.blueprint.safety.hotspot-3.message':
    'Coussin gonflable central monté sur le siège avant',
  'outlander.blueprint.safety.hotspot-4.label': 'Siège du conducteur',
  'outlander.blueprint.safety.hotspot-4.message': 'Siège du conducteur',
  'outlander.blueprint.safety.hotspot-5.label': 'Siège du passager avant',
  'outlander.blueprint.safety.hotspot-5.message': 'Siège du passager avant',

  'outlander.launcher.introduction': "Cliquez pour poser des questions sur 2026 l'outlander.",
}

export default FR
